export class WorkerSearchRequest {

    _page; // number
    _term; // string
    _workerStateIds; // number[]

    constructor() {
        this._page = 1;
        this._term = '';
        this._workerStateIds = undefined;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setWorkerState(workerState) {
        this._workerStateIds =
            workerState === 1 || workerState === 2
                ? [workerState]
                : undefined;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                company_id: undefined,
                worker_state_ids: this._workerStateIds,
                show_only_deleted: false,
                include_only_company_workers: undefined,
                include_only_contractor_workers: true,
                retrieve_worker_documentation_state: true,
                skip_contractors_inactive: true,
                skip_companies_inactive: undefined,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/list/worker-search/WorkerSearchRequest.js